import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom/dist";
import VendorSalesStatistics from "routes/vendor/VendorSalesStatistics";
import style from "./StoreManagementDetail.module.css";
import Center from "layouts/wrapper/Center";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Container from "layouts/container/Container";
import { requester } from "App";

function StoreManagementDetail(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const [data, setData] = useState();
    const [kiosks, setKiosks] = useState([]);
    const [devices, setDevices] = useState([]);
    const [isMounted, setMounted] = useState(false);
    const [salesOverview, setSalesOverview] = useState();

    useEffect(() => {
        setMounted(true);
    }, [])
    useEffect(() => {
        if (isMounted) {
            let storeData = { id: data.id }
            
            requester.getVendorStoreSalesOverview(storeData, (result) => {
                setSalesOverview(result.data);
            })
        }
    }, [isMounted])


    useEffect(() => {
        if (props.data) {
            setData(props.data);
        }
    }, [props])
    useEffect(() => {
        if (data) {
            // machines 배열을 순회하며 키오스크와 기기를 분류
            const kiosksTemp = data.machines.filter(machine => machine.orderNo === 1 || machine.orderNo === 2);
            const devicesTemp = data.machines.filter(machine => machine.orderNo !== 1 && machine.orderNo !== 2);
            setKiosks(kiosksTemp);
            setDevices(devicesTemp);
        }
    }, [data])

    const handleManage = (data) => {
        // 관리 작업 처리, 예를 들어 다른 페이지로 이동하거나 모달을 열기 등
        navigate(`/admin/store/management/detail/${data.id}`, { state: { data: data } })
    };
    return (
        <Container>
            <Container maxWidth={1200}>
                <VerticalFlex gap={40}>
                    <FlexChild>
                        <Center width={"100%"} textAlign={"left"}>
                            <P size={40} font={"gmarketSansBold"} color={"black"}>{data && data.storeName}</P>
                        </Center>
                    </FlexChild>
                    <FlexChild >
                        <HorizontalFlex gap={20}>
                            <FlexChild>
                                <div className={style.card}>
                                    <Center>
                                        <P>일일 매출액</P>
                                        <P color={"darkcyan"}>{salesOverview ? salesOverview.todayTotalPrice.toLocaleString() : 0} 원</P>
                                    </Center>

                                </div>
                            </FlexChild>
                            <FlexChild>
                                <div className={style.card}>
                                    <Center>
                                        <P>금주 매출액</P>
                                        <P color={"darkcyan"}>{salesOverview ? salesOverview.thisWeekTotalPrice.toLocaleString() : 0}원</P>
                                    </Center>

                                </div>
                            </FlexChild>
                            <FlexChild>
                                <div className={style.card}>
                                    <Center>
                                        <P>당월 매출액</P>
                                        <P color={"darkcyan"}>{salesOverview ? salesOverview.thisMonthTotalPrice.toLocaleString() : 0}원</P>
                                    </Center>

                                </div>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                        <VerticalFlex gap={20}>
                            <FlexChild>
                                <HorizontalFlex gap={20}>
                                    {
                                        kiosks.length > 0
                                            ?
                                            kiosks.map((kiosk, index) => {
                                                return (
                                                    <FlexChild key={index}>
                                                        <div className={style.card}>
                                                            <VerticalFlex gap={15}>

                                                                <FlexChild>
                                                                    <div className={style.cardHeader}>
                                                                        <P>{kiosk.vendingName}</P>

                                                                    </div>
                                                                </FlexChild>
                                                                <FlexChild>
                                                                    <img src={`data:image/png;base64,${kiosk.image}`} style={{ height: "350px" }} />
                                                                </FlexChild>
                                                                <FlexChild>
                                                                    <div className={kiosk.heartbeat ? style.statusCircleGreen : style.statusCircleRed}></div>
                                                                </FlexChild>
                                                                <FlexChild>
                                                                    <P className={kiosk.heartbeat ? style.communicationNormal : style.communicationFailure}>
                                                                        {kiosk.heartbeat ? '정상' : '통신 불량'}
                                                                    </P>
                                                                </FlexChild>
                                                            </VerticalFlex>
                                                        </div>
                                                    </FlexChild>
                                                );
                                            })
                                            :
                                            <FlexChild>
                                                <div className={style.card}>
                                                    <P>키오스크 데이터가 없습니다.</P>
                                                </div>
                                            </FlexChild>
                                    }
                                </HorizontalFlex>

                            </FlexChild>
                            <FlexChild>
                                <HorizontalFlex gap={15}>
                                    {
                                        devices.length > 0
                                        ?
                                        devices.map((device, index) => {
                                            return (
                                                <FlexChild key={device.id}>
                                                    <div className={style.card} key={index}>
                                                        <VerticalFlex gap={15}>
                                                            <FlexChild>
    
                                                                <div className={style.cardHeader}>
                                                                    <P>{device.vendingName}</P>
                                                                    <button onClick={() => handleManage(device)} className={style.manageButton}>관리</button>
                                                                </div>
                                                            </FlexChild>
                                                            <FlexChild>
                                                                {/* <div className={device.heartbeat ? style.statusCircleGreen : style.statusCircleRed}></div> */}
                                                            </FlexChild>
                                                            <FlexChild>
                                                                {/* <P className={device.heartbeat ? style.communicationNormal : style.communicationFailure}>
                                                                    {device.heartbeat ? '정상' : '통신 불량'}
                                                                </P> */}
                                                            </FlexChild>
                                                        </VerticalFlex>
                                                    </div>
                                                </FlexChild>
                                            );
                                        })
                                        :
                                        <FlexChild>
                                                <div className={style.card}>
                                                    <P>머신 데이터가 없습니다.</P>
                                                </div>
                                            </FlexChild>
                                    }
                                </HorizontalFlex>
                            </FlexChild>
                        </VerticalFlex>
                    </FlexChild>
                </VerticalFlex>
            </Container>
        </Container>
    );
}

export default StoreManagementDetail;